export enum PlaceStatus {
  ACTIVE = "ACTIVE",
  CLOSED_TEMPORARILY = "CLOSED_TEMPORARILY",
  NO_LONGER_HAS_POOL = "NO_LONGER_HAS_POOL",
  OUT_OF_BUSINESS = "OUT_OF_BUSINESS",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  UNDER_REVIEW = "UNDER_REVIEW",
  UNKNOWN = "UNKNOWN",
}
